import React, { Component } from "react";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";
import PathwayInfo from "../ScreenComponents/Pathwayinfo.js";
import { Typography } from "@material-ui/core";

const useStyles = (theme) => ({
  root: {
    position: "relative",
    height: "auto",
    padding: "2rem",
    flexgrow: 1,
  },
  headerClass: {
    color: "white",
    backgroundColor: theme.palette.primary.dark,
    padding: "5px",
    fontSize: "1em",
  },

  choiceClass: {
    color: "white",
    backgroundColor: theme.palette.primary.light,
  },
  formControl: {
    margin: theme.spacing(0),
    minWidth: 150,
  },
  info: {
    backgroundColor: theme.palette.background.paper,
  },

  MCA: {
    backgroundColor: "#b23c17",
    padding: "15px",
    color: "white",
  },
  SWP: {
    backgroundColor: "#155fa0",
    padding: "15px",
    color: "white",
  },
  RapidPrototyping: {
    backgroundColor: "#77a258",
    padding: "15px",
  },
  RapidFielding: {
    backgroundColor: "#77a258",
    padding: "15px",
  },
  UCA: {
    color: "white",
    backgroundColor: "#a44fbb",
    padding: "15px",
  },
  DBS: {
    backgroundColor: "#fdd835",
    padding: "15px",
  },
  AOS: {
    color: "white",
    backgroundColor: "#33eaff",
    padding: "15px",
  },
  notRecommended: {
    backgroundColor: theme.palette.secondary.main,
  },
  notApplicable: {
    backgroudnColor: grey[500],
  },
});

export class PathwaySelect extends Component {
  state = {
    allPathways: [
      "MCA",
      "SWP",
      "RapidPrototyping",
      "RapidFielding",
      "UCA",
      "DBS",
      "AOS",
    ],
    activePathways: [],
    dbs: false,
    showMCA: false,
    showSWP: false,
    showRapidProto: false,
    showRapidFielding: false,
    showUCA: false,
    showDBS: false,
    showAOS: false,
  };

  continue = (e) => {
    e.preventDefault();
    this.props.nextStep();
  };

  back = (e) => {
    e.preventDefault();
    this.props.prevStep();
  };

  selectPathway(choice) {
    this.props.currentContext.setPathway(choice);
    this.props.currentContext.createTailoringChoices();
  }

  toggleMCA = (e) => {
    let newBool = this.showMCA;
    this.setState({ newBool: !newBool });
    this.showMCA = newBool;
    e.preventDefault();
  };

  render() {
    const {
      showMCA,
      showSWP,
      showRapidProto,
      showRapidFielding,
      showUCA,
      showDBS,
      showAOS,
    } = this.state;
    const { classes } = this.props;
    //const {showMCA, showHideMCA} = this.props;

    return (
      <MuiThemeProvider>
        {/* Main Grid */}
        <Grid container direction="column" spacing={2} className={classes.root}>
          {/*</Grid>*/}
          {/*Main Info Block*/}
          <Grid
            item
            xs={12}
            container
            direction="row"
            flexgrow="1"
            alignItems="stretch"
            justify="center"
            align="stretch"
            spacing={1}
          >
            <Grid item xs={12} fullWidth>
              <Button
                variant="contained"
                value="MCA"
                className={classes.MCA}
                fullWidth
                disabled={this.props.currentContext.isNotApplicable("MCA")}
                onClick={() => this.setState({ showMCA: !showMCA })}
              >
                Major Capability Acquisition (MCA) Pathway
              </Button>
            </Grid>
            {showMCA ? (
              <Grid
                container
                justify="center"
                spacing={5}
                style={{ paddingTop: 20 }}
              >
                <PathwayInfo
                  summary={
                    this.props.currentContext.pathwayInformation[
                      this.props.currentContext.scenarioGroup
                    ]["Summary"]["MCA"]
                  }
                  benefits={
                    this.props.currentContext.pathwayInformation[
                      this.props.currentContext.scenarioGroup
                    ]["Benefit"]["MCA"]
                  }
                  downsides={
                    this.props.currentContext.pathwayInformation[
                      this.props.currentContext.scenarioGroup
                    ]["Downside"]["MCA"]
                  }
                  recommended={this.props.currentContext.isRecommended("MCA")}
                />
                <Grid item xs={8}>
                  {!this.props.currentContext.isRecommended("MCA") && (
                    <Typography color="textSecondary" variant="overline">
                      Based on your project's requirements, this pathway is not
                      recommended.
                    </Typography>
                  )}

                  <Button
                    fullWidth
                    value="MCA"
                    color="primary"
                    variant="contained"
                    onClick={(e) => {
                      this.continue(e);
                      this.selectPathway("MCA");
                    }}
                  >
                    Continue with the Major Capability Acquisition pathway
                  </Button>
                </Grid>
                <Grid item xs={12}></Grid>
              </Grid>
            ) : null}

            <Grid item xs={12} fullWidth>
              <Button
                variant="contained"
                value="SWP"
                className={classes.SWP}
                fullWidth
                disabled={this.props.currentContext.isNotApplicable("SWP")}
                onClick={() => this.setState({ showSWP: !showSWP })}
              >
                Software Acquisition (SWP) Pathway
              </Button>
            </Grid>

            {showSWP ? (
              <Grid
                container
                justify="center"
                spacing={5}
                style={{ paddingTop: 20 }}
              >
                <PathwayInfo
                  summary={
                    this.props.currentContext.pathwayInformation[
                      this.props.currentContext.scenarioGroup
                    ]["Summary"]["SWP"]
                  }
                  benefits={
                    this.props.currentContext.pathwayInformation[
                      this.props.currentContext.scenarioGroup
                    ]["Benefit"]["SWP"]
                  }
                  downsides={
                    this.props.currentContext.pathwayInformation[
                      this.props.currentContext.scenarioGroup
                    ]["Downside"]["SWP"]
                  }
                  recommended={this.props.currentContext.isRecommended("SWP")}
                />
                <Grid item xs={8}>
                  {!this.props.currentContext.isRecommended("SWP") && (
                    <Typography color="textSecondary" variant="overline">
                      Based on your project's requirements, this pathway is not
                      recommended.
                    </Typography>
                  )}
                  <Button
                    fullWidth
                    value="SWP"
                    color="primary"
                    variant="contained"
                    onClick={(e) => {
                      this.continue(e);
                      this.selectPathway("SWP");
                    }}
                  >
                    Continue with the Software Acquisition pathway
                  </Button>
                </Grid>
                <Grid item xs={12}></Grid>
              </Grid>
            ) : null}

            <Grid item xs={12} fullWidth>
              <Button
                variant="contained"
                value="UCA"
                className={classes.UCA}
                fullWidth
                disabled={this.props.currentContext.isNotApplicable("UCA")}
                onClick={() => this.setState({ showUCA: !showUCA })}
                //onClick={this.continue}
              >
                Urgent Acquisition (UCA) Pathway
              </Button>
            </Grid>

            {showUCA ? (
              <Grid
                container
                justify="center"
                spacing={5}
                style={{ paddingTop: 20 }}
              >
                <PathwayInfo
                  summary={
                    this.props.currentContext.pathwayInformation[
                      this.props.currentContext.scenarioGroup
                    ]["Summary"]["UCA"]
                  }
                  benefits={
                    this.props.currentContext.pathwayInformation[
                      this.props.currentContext.scenarioGroup
                    ]["Benefit"]["UCA"]
                  }
                  downsides={
                    this.props.currentContext.pathwayInformation[
                      this.props.currentContext.scenarioGroup
                    ]["Downside"]["UCA"]
                  }
                  recommended={this.props.currentContext.isRecommended("UCA")}
                />
                <Grid item xs={8}>
                  {!this.props.currentContext.isRecommended("UCA") && (
                    <Typography color="textSecondary" variant="overline">
                      Based on your project's requirements, this pathway is not
                      recommended.
                    </Typography>
                  )}
                  <Button
                    fullWidth
                    value="UCA"
                    color="primary"
                    variant="contained"
                    onClick={(e) => {
                      this.continue(e);
                      this.selectPathway("UCA");
                    }}
                  >
                    Continue with the Urgent Acquisition pathway
                  </Button>
                </Grid>
                <Grid item xs={12}></Grid>
              </Grid>
            ) : null}

            <Grid item xs={12} fullWidth>
              <Button
                variant="contained"
                value="RapidPrototyping"
                className={classes.RapidPrototyping}
                fullWidth
                disabled={this.props.currentContext.isNotApplicable(
                  "RapidPrototyping"
                )}
                onClick={() =>
                  this.setState({ showRapidProto: !showRapidProto })
                }
                //onClick={this.continue}
              >
                Middle Tier of Acquisition - Rapid Prototyping (MTA-RP) Pathway
              </Button>
            </Grid>

            {showRapidProto ? (
              <Grid
                container
                justify="center"
                spacing={5}
                style={{ paddingTop: 20 }}
              >
                <PathwayInfo
                  summary={
                    this.props.currentContext.pathwayInformation[
                      this.props.currentContext.scenarioGroup
                    ]["Summary"]["RapidPrototyping"]
                  }
                  benefits={
                    this.props.currentContext.pathwayInformation[
                      this.props.currentContext.scenarioGroup
                    ]["Benefit"]["RapidPrototyping"]
                  }
                  downsides={
                    this.props.currentContext.pathwayInformation[
                      this.props.currentContext.scenarioGroup
                    ]["Downside"]["RapidPrototyping"]
                  }
                  recommended={this.props.currentContext.isRecommended(
                    "RapidPrototyping"
                  )}
                />
                <Grid item xs={8}>
                  {!this.props.currentContext.isRecommended(
                    "RapidPrototyping"
                  ) && (
                    <Typography color="textSecondary" variant="overline">
                      Based on your project's requirements, this pathway is not
                      recommended.
                    </Typography>
                  )}
                  <Button
                    fullWidth
                    value="RapidPrototyping"
                    color="primary"
                    variant="contained"
                    onClick={(e) => {
                      this.continue(e);
                      this.selectPathway("RapidPrototyping");
                    }}
                  >
                    Continue with the Rapid Prototyping pathway
                  </Button>
                </Grid>
                <Grid item xs={12}></Grid>
              </Grid>
            ) : null}

            <Grid item xs={12} fullWidth>
              <Button
                variant="contained"
                value="RapidFielding"
                className={classes.RapidFielding}
                disabled={this.props.currentContext.isNotApplicable(
                  "RapidFielding"
                )}
                fullWidth
                onClick={() =>
                  this.setState({ showRapidFielding: !showRapidFielding })
                }
                //onClick={this.continue}
              >
                Middle Tier of Acquisition - Rapid Fielding (MTA-RF) Pathway
              </Button>
            </Grid>

            {showRapidFielding ? (
              <Grid
                container
                justify="center"
                spacing={5}
                style={{ paddingTop: 20 }}
              >
                <PathwayInfo
                  summary={
                    this.props.currentContext.pathwayInformation[
                      this.props.currentContext.scenarioGroup
                    ]["Summary"]["RapidFielding"]
                  }
                  benefits={
                    this.props.currentContext.pathwayInformation[
                      this.props.currentContext.scenarioGroup
                    ]["Benefit"]["RapidFielding"]
                  }
                  downsides={
                    this.props.currentContext.pathwayInformation[
                      this.props.currentContext.scenarioGroup
                    ]["Downside"]["RapidFielding"]
                  }
                  recommended={this.props.currentContext.isRecommended(
                    "RapidFielding"
                  )}
                />
                <Grid item xs={8}>
                  {!this.props.currentContext.isRecommended(
                    "RapidFielding"
                  ) && (
                    <Typography color="textSecondary" variant="overline">
                      Based on your project's requirements, this pathway is not
                      recommended.
                    </Typography>
                  )}
                  <Button
                    fullWidth
                    value="RapidFielding"
                    color="primary"
                    variant="contained"
                    onClick={(e) => {
                      this.continue(e);
                      this.selectPathway("RapidFielding");
                    }}
                  >
                    Continue with the Rapid Fielding pathway
                  </Button>
                </Grid>
                <Grid item xs={12}></Grid>
              </Grid>
            ) : null}

            <Grid item xs={12} fullWidth>
              <Button
                variant="contained"
                value="DBS"
                className={classes.DBS}
                fullWidth
                disabled={this.props.currentContext.isNotApplicable("DBS")}
                onClick={() => this.setState({ showDBS: !showDBS })}
                //onClick={this.continue}
              >
                Defense Business Systems (DBS) Pathway
              </Button>
            </Grid>

            {showDBS ? (
              <Grid
                container
                justify="center"
                spacing={5}
                style={{ paddingTop: 20 }}
              >
                <PathwayInfo
                  summary={
                    this.props.currentContext.pathwayInformation[
                      this.props.currentContext.scenarioGroup
                    ]["Summary"]["DBS"]
                  }
                  benefits={
                    this.props.currentContext.pathwayInformation[
                      this.props.currentContext.scenarioGroup
                    ]["Benefit"]["DBS"]
                  }
                  downsides={
                    this.props.currentContext.pathwayInformation[
                      this.props.currentContext.scenarioGroup
                    ]["Downside"]["DBS"]
                  }
                  recommended={this.props.currentContext.isRecommended("DBS")}
                />
                <Grid item xs={8}>
                  {!this.props.currentContext.isRecommended("DBS") && (
                    <Typography color="textSecondary" variant="overline">
                      Based on your project's requirements, this pathway is not
                      recommended.
                    </Typography>
                  )}
                  <Button
                    fullWidth
                    value="DBS"
                    color="primary"
                    variant="contained"
                    onClick={(e) => {
                      this.continue(e);
                      this.selectPathway("DBS");
                    }}
                  >
                    Continue with the DBS pathway
                  </Button>
                </Grid>
                <Grid item xs={12}></Grid>
              </Grid>
            ) : null}

            <Grid item xs={12} fullWidth>
              <Button
                variant="contained"
                value="AOS"
                className={classes.AOS}
                fullWidth
                disabled={true}
                //disabled={this.props.currentContext.isNotApplicable("AOS")}
                onClick={() => this.setState({ showAOS: !showAOS })}
                //onClick={this.continue}
              >
                Acquisition of Services Pathway
              </Button>
            </Grid>
            {showAOS ? (
              <Grid
                container
                justify="center"
                spacing={5}
                style={{ paddingTop: 20 }}
              >
                <PathwayInfo
                  summary={
                    this.props.currentContext.pathwayInformation[
                      this.props.currentContext.scenarioGroup
                    ]["Summary"]["AOS"]
                  }
                  benefits={
                    this.props.currentContext.pathwayInformation[
                      this.props.currentContext.scenarioGroup
                    ]["Benefit"]["AOS"]
                  }
                  downsides={
                    this.props.currentContext.pathwayInformation[
                      this.props.currentContext.scenarioGroup
                    ]["Downside"]["AOS"]
                  }
                  recommended={this.props.currentContext.isRecommended("AOS")}
                />
                <Grid item xs={8}>
                  {!this.props.currentContext.isRecommended("AOS") && (
                    <Typography color="textSecondary" variant="overline">
                      Based on your project's requirements, this pathway is not
                      recommended.
                    </Typography>
                  )}
                  <Button
                    fullWidth
                    value="AOS"
                    color="primary"
                    variant="contained"
                    onClick={(e) => {
                      this.continue(e);
                      this.selectPathway("AOS");
                    }}
                  >
                    Continue with the AOS pathway
                  </Button>
                </Grid>
                <Grid item xs={12}></Grid>
              </Grid>
            ) : null}
          </Grid>
          {/*
            <FormControl component="fieldset">
            <FormLabel component="legend">Test</FormLabel>
              <RadioGroup aria-label="pathway" name="pathwaySelection" value={this.props.currentContext.pathwayChoice} onChange={handleChange('pathwayChoice')}>
                <Grid item className={classes.MCA}><FormControlLabel value="MCA" control={<Radio />} label="Major Capability Acquisition (MCA) Pathway" /></Grid>
                <Grid item><FormControlLabel value="SWP" control={<Radio />} label="Software Acquisition (SWP) Pathway" /></Grid>
                <Grid item><FormControlLabel value="UCA" control={<Radio />} label="Urgent Acquisition (UCA) Pathway" /></Grid>
                <Grid item><FormControlLabel value="RapidPrototyping" control={<Radio />} label="Middle Tier of Acquisition - Rapid Prototyping (MTA-RP) Pathway" /></Grid>
                <Grid item><FormControlLabel value="RapidFielding" control={<Radio />} label="Middle Tier of Acquisition - Rapid Fielding (MTA-RF) Pathway"/></Grid>
                <Grid item><FormControlLabel value="DBS" control={<Radio />} label="Defense Business Systems (DBS) Pathway" /></Grid>
                <Grid item><FormControlLabel value="AOS" control={<Radio />} label="Acquisition of Services Pathway" /></Grid>
              </RadioGroup>
            </FormControl>
            */}
          {/*END Main Info Block*/}

          {/*Continue/Back Buttons*/}
          <Grid item container direction="row" spacing={0}>
            <Grid item xs={12}>
              <Button
                fullWidth
                color="secondary"
                variant="contained"
                onClick={this.back}
              >
                Back
              </Button>
            </Grid>

            {/* END Continue/Back Buttons */}
          </Grid>
          {/* END Main Grid */}
        </Grid>
      </MuiThemeProvider>
      /*
      <MuiThemeProvider>
        <>
          <Dialog
            open
            fullWidth
            maxWidth='sm'
          >
            <AppBar title="Enter Personal Details" />
            <TextField
              placeholder="Enter text"
              label="test1"
              onChange={handleChange('occupation')}
              defaultValue={values.occupation}
              margin="normal"
              fullWidth
            />
            <br />
            <TextField
              placeholder="Enter text"
              label="test2"
              onChange={handleChange('city')}
              defaultValue={values.city}
              margin="normal"
              fullWidth
            />
            <br />
            <TextField
              placeholder="Enter text"
              label="test3"
              onChange={handleChange('bio')}
              defaultValue={values.bio}
              margin="normal"
              fullWidth
            />
            <br />

            <Button
              color="secondary"
              variant="contained"
              onClick={this.back}
            >Back</Button>

            <Button
              color="primary"
              variant="contained"
              onClick={this.continue}
            >Continue</Button>
          </Dialog>
        </>
      </MuiThemeProvider>
      */
    );
  }
}

export default withStyles(useStyles, { withTheme: true })(PathwaySelect);
